import { Button } from '@britishcouncil/react-admin';
import { useIntParam } from 'hooks';
import { generatePath, useBlocker, useLocation } from 'react-router';
import { Modal, ModalActions, ModalContent, ModalHeader } from 'semantic-ui-react';
import { ROUTING_PATHS } from 'const';
import { EditRoomRouteState } from './structures/types';

export const UnsavedChangesModal = () => {
  const sessionId = useIntParam('sessionId');
  const location = useLocation();
  const routeState = (location.state ?? {}) as EditRoomRouteState;
  const editedRoomId = routeState.roomId;
  const { speakingSessionDetails } = ROUTING_PATHS;
  const speakingDetailsPath = generatePath(speakingSessionDetails.absolutePath, { sessionId });

  const blocker = useBlocker(({ nextLocation }) => {
    return editedRoomId !== undefined && nextLocation.pathname !== speakingDetailsPath;
  });

  return (
    <Modal open={blocker.state === 'blocked'} size="small">
      <ModalHeader>Unsaved changes</ModalHeader>
      <ModalContent>
        <div>You have unsaved slot changes for a room.</div>
        <div>Would you like to discard changes or continue editing?</div>
      </ModalContent>
      <ModalActions>
        <Button secondary onClick={blocker.proceed}>
          Discard changes
        </Button>
        <Button primary onClick={blocker.reset}>
          Continue editing
        </Button>
      </ModalActions>
    </Modal>
  );
};
